<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	 

	export default {
		name: 'app',
		components: {
		 
		}
	}
</script>

<style>
	@import '../static/base.css';
	@import '../static/css3.css';

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}
	.index_warp .group .item .dm .price .icon{
		width: 45px;
		
	}
</style>
